export default __webpack_public_path__ + "static/media/resnetgru3.2cd47887.png";